import React, { useEffect, useState } from 'react'
import { GetGstCalculation } from '../../Api/commonAPI';
import { decryptData } from "../../common/encryptAnddecryptData";

const TotalPrice = ({ userDetails, token, selectedId, setOpen, total, setTotal, handlePurchase, isLoading }) => {

    const [loading, setLoading] = useState(true);

    const fetchPaymentHistory = async () => {
        try {
            const response = await GetGstCalculation(userDetails, selectedId, token);
            const data = response.data;
            const decrypted = decryptData(data?.data);
            setTotal(decrypted);
            setLoading(false);
        } catch (error) {
            console.error("Points fetch error:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPaymentHistory();
    }, []);

    return (
        <>
            {!loading && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered" style={{ display: "flex", justifyContent: "center" }}>
                        <div className="modal-content" style={{ maxHeight: '80vh', maxWidth: "500px" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Total Price</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setOpen(false)}
                                ></button>
                            </div>

                            <div className="modal-body overflow-auto" style={{ maxHeight: '60vh' }}>
                                <div
                                    className="mb-4 p-3 border rounded shadow-sm bg-light"
                                >
                                    <div className="row mb-2">
                                        <div className="col-6 fw-bold">Plan Price :</div>
                                        <div className="col-6">₹{total?.Price}</div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-6 fw-bold">GST ({total?.Gst}%) :</div>
                                        <div className="col-6">₹{total?.GstPrice}</div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-6 fw-bold">Total Amount :</div>
                                        <div
                                            className="col-6"
                                        >
                                            ₹{total?.TotalAmount}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button className="close-warning-button" disabled={isLoading} onClick={() => handlePurchase()}>
                                    {isLoading ? 'Purchasing' : 'Purchase Now'}
                                </button>
                                <button onClick={() => setOpen(false)} className="close-warning-button">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default TotalPrice
